<template>
<router-view/>
</template>

<script>
export default {
  name: "simpleLayout"
}
</script>

<style scoped>

</style>